import { Box } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LegacyDialog } from '~/legacy-components/LegacyDialog';

import { vacationDaysHistoryData } from '../data';

import { useSxStyles } from './useStyles';

type Props = {
  open: boolean;
  onClose: () => void;
  bnEnableVacBank: boolean;
  vacHistoryTableData: vacationDaysHistoryData[];
};

export const VacationDaysHistoryDialog = ({
  open,
  onClose,
  bnEnableVacBank,
  vacHistoryTableData,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <LegacyDialog
      open={open}
      onClose={() => {
        onClose();
      }}
      onSave={() => {
        onClose();
      }}
      showSave={false}
      icon={'fa fa-file-text-o'}
      showCancel={false}
      title={'laVacBalHistory'}
      maxWidth={'lg'}
    >
      <Box component="table" sx={sxStyles.table}>
        <thead>
          <tr>
            <th>{t('laVacBal')}</th>
            {!bnEnableVacBank ? (
              <>
                <th>{t('laVacBalExtra')}</th>
                <th>{t('VExtra supplement1')}</th>
                <th>{t('Used')}</th>
                <th>{t('VExtra supplement2')}</th>
                <th>{t('Used')}</th>
              </>
            ) : (
              <>
                <th>{t('laVacationBank1')}</th>
                <th>{t('laVacationBank2')}</th>
                <th>{t('laVacationBank3')}</th>
              </>
            )}

            <th>{t('laStartDate')}</th>
            <th>{t('laEndDate')}</th>
            <th>{t('laDays')}</th>
            <th>{t('laReason')}</th>
            <th>{t('laInfo')}</th>
            <th>{t('laUpdated')}</th>
            <th>{t('laUpdatedName')}</th>
          </tr>
        </thead>
        <tbody>
          {vacHistoryTableData && vacHistoryTableData.length > 0
            ? vacHistoryTableData.map(
                (data: vacationDaysHistoryData, index: number) => {
                  return (
                    <tr key={index}>
                      <td>{data.fVacationBalance}</td>
                      {!bnEnableVacBank ? (
                        <>
                          <td>{data.fVacationBalanceExtra}</td>
                          <td>{data.fVacationBalanceSuppl1}</td>
                          <td>{data.fVacationBalanceSuppl1Spent}</td>
                          <td>{data.fVacationBalanceSuppl2}</td>
                          <td>{data.fVacationBalanceSuppl2Spent}</td>
                        </>
                      ) : (
                        <>
                          <td>{data.fVacationBalanceBank1}</td>
                          <td>{data.fVacationBalanceBank2}</td>
                          <td>{data.fVacationBalanceBank3}</td>
                        </>
                      )}

                      <td>
                        {data.fVacationBalanceDeduction
                          ? moment(
                              data.fVacationBalanceDeduction
                                .fDeductionStartDate,
                            ).format('DD.MM.YYYY')
                          : ''}
                      </td>
                      <td>
                        {data.fVacationBalanceDeduction
                          ? moment(
                              data.fVacationBalanceDeduction.fDeductionEndDate,
                            ).format('DD.MM.YYYY')
                          : ''}
                      </td>
                      <td>
                        {data.fVacationBalanceDeduction
                          ? data.fVacationBalanceDeduction.fDeductionDays
                          : ''}
                      </td>
                      <td>
                        {data.fVacationBalanceDeduction
                          ? data.fVacationBalanceDeduction.fDeductionReason
                          : ''}
                      </td>
                      <td>
                        {data.fVacationBalanceDeduction
                          ? data.fVacationBalanceDeduction.fDeductionInfo
                          : ''}
                      </td>
                      <td>
                        {moment(data.fVacationBalanceUpdatedTime).format(
                          'DD.MM.YYYY',
                        )}
                      </td>
                      <td>
                        {data.fVacationBalanceUpdatedName
                          ? data.fVacationBalanceUpdatedName
                          : ''}
                      </td>
                    </tr>
                  );
                },
              )
            : ''}
        </tbody>
      </Box>
    </LegacyDialog>
  );
};
